import './polyfills'; 
import { bootstrapApplication, BrowserModule, Meta, Title } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { HttpClient, HttpClientModule, provideHttpClient } from '@angular/common/http';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { LoginEffects } from './app/source/appstates/loginstates/loginEffects';
import { PlayerEffects } from './app/source/appstates/playerstates/playerEffects';
import { CashierEffects } from './app/source/appstates/cashierstates/cashierEffects';
import { provideRouter } from '@angular/router';
import { routes } from './app/app.routes';
import '@angular/compiler'
import { PlaceholderDirective } from './app/media/PlaceholderDirective';
import { AppReducer } from './app/source/appstates/appState';
import { ReplacePipe } from './app/pipes/replace.pipe';
import { NgxMarqueeModule } from 'ngx-marquee';
import { importProvidersFrom } from '@angular/core';
import { TranslateLoader, TranslateModule, TranslateService, TranslateStore } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MY_DATE_FORMATS } from './app/custom-date-format';
import { QRCodeModule } from 'angularx-qrcode';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { RouterModule } from '@angular/router';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/languages/', '.json');
}
bootstrapApplication(AppComponent,
  {
    providers: [
      { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
      Meta,
      Title,
      QRCodeModule,
      CarouselModule,
      StatusBar,
      SplashScreen,
      ReplacePipe,
      HttpClientModule,
      NgxMarqueeModule,
      ReactiveFormsModule,
      provideHttpClient(),
      provideStore(AppReducer),
      provideEffects([LoginEffects, PlayerEffects, CashierEffects]),
      provideRouter(routes),
      PlaceholderDirective,

      importProvidersFrom(
        TranslateModule.forRoot({
          loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient],
          }
        })
      ),
      TranslateStore,
      provideAnimationsAsync(),
      TranslateService,
    ],

    ...appConfig.providers
  })
  .catch((err) => console.error(err));